import { BaseApi } from "api/BaseApi.ts";

import GetCountriesResponse = App.Http.Responses.Country.GetCountriesResponse;

class CentralCountryApi extends BaseApi {
    async index(): Promise<GetCountriesResponse> {
        return this.get<GetCountriesResponse, void>("/countries");
    }
}

export const centralCountryApi = new CentralCountryApi();
